import React from 'react';
import { Nav, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faTh, 
  faHome, 
  faUsers, 
  faChartBar, 
  faSearch,
  faStar,
  faHeart,
  faEye
} from '@fortawesome/free-solid-svg-icons';

interface Tab {
  id: string;
  label: string;
  icon: string;
  badge?: number;
  disabled?: boolean;
}

interface PortalNavigationProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

const iconMap = {
  'grid': faTh,
  'home': faHome,
  'users': faUsers,
  'bar-chart-2': faChartBar,
  'search': faSearch,
  'star': faStar,
  'heart': faHeart,
  'eye': faEye
};

const PortalNavigation: React.FC<PortalNavigationProps> = ({
  tabs,
  activeTab,
  onTabChange
}) => {
  return (
    <Nav variant="pills" className="portal-navigation">
      {tabs.map((tab) => (
        <Nav.Item key={tab.id}>
          <Nav.Link
            active={activeTab === tab.id}
            onClick={() => !tab.disabled && onTabChange(tab.id)}
            disabled={tab.disabled}
            className={`portal-nav-link ${tab.disabled ? 'disabled' : ''}`}
          >
            <FontAwesomeIcon 
              icon={iconMap[tab.icon as keyof typeof iconMap] || faTh} 
              className="me-2" 
            />
            {tab.label}
            {tab.badge && (
              <Badge bg="danger" className="ms-2">
                {tab.badge}
              </Badge>
            )}
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};

export default PortalNavigation;